import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';
import { ErrorHandlingService } from './error-handling.service';
import { retryWithBackoff, timeoutWithFallback } from './retry-operators.service';

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {

  // Use environment variable for API key
  private apiKey: string = environment.geocodingApiKey;

  constructor(private http: HttpClient, private loc:AuthService, private errorHandling: ErrorHandlingService) {}

  getGeolocation(latitude: number, longitude: number): Observable<any> {
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${this.apiKey}`;
    return this.http.get(url).pipe(
      timeoutWithFallback(10000, 'Location lookup timed out. Please try again.'),
      retryWithBackoff({ maxRetries: 2, baseDelay: 1000 }),
      catchError((error: HttpErrorResponse) => this.errorHandling.handleError(error, {
        customMessage: 'Unable to get location details. Please check your internet connection.',
        showToast: true
      }))
    );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Backend error
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }
    if(errorMessage){
      localStorage.setItem('msgerror', "User denied Geolocation");
      this.loc.signouts();
    }
    return throwError(() => new Error(errorMessage));
  }
}

// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Observable, catchError, of } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
// export class GeocodingService {

//   constructor(private http: HttpClient) {}

//   // Replaces OpenCage API with free ipapi.co API
//   getGeolocation(latitude: number, longitude: number): Observable<any> {
//     return this.http.get('https://ipapi.co/json').pipe(
//       catchError(() => {
//         console.warn("Location lookup failed, using fallback.");
//         return of(null);  // Never throw errors
//       })
//     );
//   }
// }
